import Average from './Average';

export default Average;
